import { useEffect, useRef, useState } from 'react';

function useObserver({ rootMargin = '0px 0px 0px 0px' } = {}) {
  const [isInViewport, setIsInViewport] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsInViewport(entry.isIntersecting),
      { rootMargin }
    );

    observer.observe(node);

    // eslint-disable-next-line
    return () => {
      observer.disconnect();
    };
  }, [rootMargin]);

  return { ref, isInViewport };
}

export default useObserver;
